import styled from '@emotion/styled';
import theme from '../styles/theme';

const Wrapper = styled.div`
  text-align: center;
  line-height: 1.2;
`;
const Status = styled.div`
  font-size: 160px;
  color: ${theme.colors.primary};
`;
const Message = styled.div`
  font-size: 50px;
`;

const NotFoundPage = () => {
  return (
    <Wrapper>
      <Status>404</Status>
      <Message>NOT FOUND!</Message>
    </Wrapper>
  );
};

export default NotFoundPage;
